import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { AccountDetails } from '../models';

@Injectable()
export class AccountDetailsService {
  protected path = 'account';
  constructor(private httpService: HttpService) {}

  public getAccountDetails(): Observable<AccountDetails> {
    return this.httpService.makeGet<AccountDetails>(this.path);
  }
  public personalDetails(payload: any): Observable<any> {
    return this.httpService.makePost<any, any>('updateaccountdetails', payload);
  }

  public changePassword(payload: any): Observable<any> {
    return this.httpService.makePost<any, any>('changeaccountpassword', payload);
  }

  public deactivateAccount(): Observable<any> {
    return this.httpService.makePost<any, any>('requestaccountremoval', null, null);
  }
}
